<template>
  <CollapsibleComponent :slots="[{slot:'marketplaceAdministration', title: $t('marketplaceAdministration.distributionSettings')}]">
    <template v-slot:marketplaceAdministration.button>
      <EditButton v-model="edit" @save="onCardSave" @discard="onCardDiscard"/>
    </template>
    <template v-slot:marketplaceAdministration>
      <!--  TODO tooltip    -->
      <DistributionLevelsComponent v-if="!edit" :steps="localModel" :strategyOptions="strategyOptions"/>
      <template v-if="edit">
        <DistributionLevelEditorItemComponent
          v-for="(step, index) in localModel" :key="step._internal_id"
          v-model="localModel[index]"
          :step="index+1" :strategyOptions="strategyOptions"
          :last="localModel.length - 1 === index"
          @deleted="onDelete(index)">

          <template v-for="slot in strategyOptions.map(option => option.value)" v-slot:[slot]="slotProps">
            <slot :name="slot" v-bind="slotProps"></slot>
          </template>

        </DistributionLevelEditorItemComponent>

        <div class="add-button-wrapper d-flex justify-center py-3">
          <ButtonTertiaryAction @click="addStep">
            <template v-slot:text>Neue Stufe</template>
          </ButtonTertiaryAction>
        </div>
      </template>
    </template>
  </CollapsibleComponent>
</template>

<script>
import DistributionLevelsComponent from "@/components/lead/marketplace/distribution/DistributionLevelsComponent";
import {reactive, ref, watch} from "@vue/composition-api";
import DistributionLevelEditorItemComponent
  from "@/components/lead/marketplace/distribution/DistributionLevelEditorItemComponent";
import CollapsibleComponent from "@/components/profile/CollapsibleComponent";
import ButtonTertiaryAction from "@/components/buttons/ButtonTertiaryAction";
import EditButton from "@/components/buttons/EditButton";

export default {
  name: "DistributionSettingsComponent",
  components: {
    EditButton,
    ButtonTertiaryAction,
    CollapsibleComponent, DistributionLevelEditorItemComponent, DistributionLevelsComponent
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    strategyOptions: {
      type: Array,
      default: () => []
    }
  },
  setup(props, {emit}) {
    // local model state

    const edit = ref(false)

    const localModel = ref([])

    function resetLocalModel() {
      localModel.value = props.value.map(step => Object.assign({}, {...step, _internal_id: Math.random()}))
    }

    resetLocalModel()
    watch(
      () => props.value,
      () => {
        resetLocalModel()
      },
      {deep: true}
    )

    function onDelete(index) {
      localModel.value.splice(index, 1)
    }

    function addStep() {
      localModel.value.push(reactive({
        strategy: '',
        time: '00:00:00',
        edit_mode: true,
        _internal_id: Math.random()
      }))
    }

    function onCardSave(){
      emit('input', localModel.value.map(step => {
        let output = Object.assign({}, step)
        delete output._internal_id
        return output
      }))
    }

    function onCardDiscard(){
      resetLocalModel()
    }

    return {localModel, addStep, onDelete, edit, onCardSave, onCardDiscard}
  }
}
</script>

<style scoped lang="scss">
.add-button-wrapper {
  position: relative;
  padding-left: 172px;

  &::before {
    position: absolute;
    top: -32px;
    left: 85px;
    bottom: 50%;
    z-index: 1;
    border-left: 1px dashed map-get($grey, 'lighten-blue-1');
    content: '';
    display: block;
    width: 1px;
  }

  &::after {
    position: absolute;
    top: 50%;
    left: 69px;
    z-index: 2;
    background-color: map-get($grey, 'lighten-blue-1');
    border-radius: 50%;
    content: '';
    display: block;
    transform: translateY(-50%);
    width: 32px;
    height: 32px;
  }
}
</style>
